// Tiny shared helpers for the recurring series UI.

export const DOW_LABELS = ['', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export function formatDays(days) {
  if (!days || !days.length) return '—';
  return days.map((d) => DOW_LABELS[d]).join(', ');
}

/** "16:00-17:00" + duration=3 → "16:00-19:00". Fallback: returns input slot. */
export function formatTimeRange(timeSlot, durationHours) {
  if (!timeSlot || !timeSlot.includes('-')) return timeSlot || '';
  const [startStr] = timeSlot.split('-');
  const [hStr, mStr] = startStr.split(':');
  const startH = parseInt(hStr, 10);
  const startM = parseInt(mStr || '0', 10);
  if (Number.isNaN(startH)) return timeSlot;
  const dur = Number(durationHours || 1);
  const totalMin = startH * 60 + startM + dur * 60;
  const endH = Math.floor(totalMin / 60) % 24;
  const endM = totalMin % 60;
  const pad = (n) => String(n).padStart(2, '0');
  return `${pad(startH)}:${pad(startM)}-${pad(endH)}:${pad(endM)}`;
}

/**
 * Series may belong to a guest or a registered customer. Read the canonical
 * customer_name/email/phone fields populated server-side in commit_series.
 * Falls back to legacy guest-only shape for older series docs.
 */
export function customerInfo(series) {
  if (!series) return { name: '—', email: null, phone: null };
  const name =
    series.customer_name ||
    series.customer?.guest?.name ||
    'Customer';
  const email =
    series.customer_email ||
    series.customer?.guest?.email ||
    null;
  const phone =
    series.customer_phone ||
    series.customer?.guest?.phone ||
    null;
  return { name, email, phone };
}
